import { DEMO_MODE_INITIATOR_ACTIVE, DEMO_MODE_TLC_ACTIVE } from '../actions/types'

const demoModeTextContents = {
    title: 'Vous-êtes actuellement en mode démonstration.',
    texts: [
        "Les fonctionnalités sont les mêmes que lors d'une téléconsultation classique.",
        "Aucun document de facturation ne sera généré à l'issue de cette démonstration",
    ],
}

interface DemoStore {
    isDemoModeInitiatorOn: boolean
    isDemoModeTlc: boolean
    demoModeTextContents: {
        title: string
        texts: Array<string>
    }
}

const INITIAL_STATE: DemoStore = {
    isDemoModeInitiatorOn: false,
    isDemoModeTlc: false,
    demoModeTextContents,
}

export default (state = INITIAL_STATE, action: any): DemoStore => {
    switch (action.type) {
        case DEMO_MODE_INITIATOR_ACTIVE:
            return {
                ...state,
                isDemoModeInitiatorOn: action.payload.status,
            }
        case DEMO_MODE_TLC_ACTIVE:
            return {
                ...state,
                isDemoModeTlc: action.payload.status,
            }
        default:
            return state
    }
}
